import {
  Avatar,
  Box,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card.js';
import React from 'react';
import { useTranslation } from 'i18n/TranslationProvider';
import { FaCrown } from 'react-icons/fa';

// ✅ First component: ProfileBanner
export default function ProfileBanner({ user, ...rest }) {
  const { t } = useTranslation();
  const textColorPrimary = useColorModeValue('navy.700', 'white');
  const textColorSecondary = useColorModeValue('gray.600', 'gray.300');
  const panelBg = useColorModeValue(
    'rgba(255, 255, 255, 0.90)',
    'rgba(15, 28, 63, 0.72)',
  );
  const panelBorder = useColorModeValue(
    'rgba(255,255,255,0.95)',
    'rgba(255,255,255,0.16)',
  );
  const vipText = useColorModeValue('orange.700', 'orange.200');
  const vipIconBg = useColorModeValue(
    'linear-gradient(135deg, #F59E0B, #EA580C)',
    'linear-gradient(135deg, #FBBF24, #F97316)',
  );
  const vipIconRing = useColorModeValue('white', 'rgba(15, 28, 63, 0.95)');
  const avatarName = user?.displayName || user?.email || 'U';

  return (
    <Card
      mb={{ base: '0px', lg: '20px' }}
      align="center"
      borderRadius={{ base: '22px', md: '28px' }}
      border="1px solid"
      borderColor={panelBorder}
      bg={panelBg}
      backdropFilter="blur(10px)"
      boxShadow="0 24px 60px rgba(9, 30, 66, 0.16)"
      p={{ base: 5, md: 6 }}
      {...rest}
    >
      <Box position="relative" display="inline-flex">
        <Avatar
          mx="auto"
          name={avatarName}
          h="88px"
          w="88px"
          bg="#11047A"
          color="white"
          fontWeight="700"
          fontSize="2xl"
        />
        {user?.isVIP && (
          <Box
            position="absolute"
            top="-2px"
            right="-2px"
            w="24px"
            h="24px"
            borderRadius="full"
            border="2px solid"
            borderColor={vipIconRing}
            bgImage={vipIconBg}
            color="white"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 8px 16px rgba(0, 0, 0, 0.22)"
          >
            <Icon as={FaCrown} boxSize={3} />
          </Box>
        )}
      </Box>
      <Text color={textColorPrimary} fontWeight="bold" fontSize="xl" mt="12px">
        {t('Name')}: {user.displayName || t('No Name')}
      </Text>
      {user?.isVIP && (
        <Text mt="4px" color={vipText} fontWeight="700" fontSize="sm">
          {t('VIP')}
        </Text>
      )}
      <Text color={textColorSecondary} fontSize="sm" fontWeight="600">
        {t('Email')}: {user.email || t('No Email')}
      </Text>
      <Text color={textColorSecondary} fontSize="sm" fontWeight="600">
        {t('Role')}: {t(user.role) || t('N/A')}
      </Text>
    </Card>
  );
}
